// extracted by mini-css-extract-plugin
export default {"image":"ImageComponent_image__0762+","noImage":"ImageComponent_noImage__UBupI"};